import api from './api'

export interface OnboardingStatus {
  pricingComplete: boolean
  brandingComplete: boolean
  usersInvited: boolean
  customersAdded: boolean
  quickbooksConnected: boolean
}

export const getOnboardingStatus = async (): Promise<OnboardingStatus> => {
  const response = await api.get('/company/onboarding-status')
  return response.data.data
}

export const dismissOnboarding = async (): Promise<void> => {
  await api.post('/users/me/dismiss-onboarding')
}

export function dismissKey(tenantId: string) {
  return `paver_onboarding_dismissed_${tenantId}`
}

/** First-transition "open the corner panel once" marker — cosmetic, so localStorage-only. */
export function introSeenKey(tenantId: string) {
  return `paver_setup_guide_intro_${tenantId}`
}

/**
 * Single source of truth for "has this user dismissed onboarding?".
 * The server value wins when it EXPLICITLY says not-dismissed (false): a stale
 * localStorage `true` (it survives logout — Known-Edge-Cases #27) is purged,
 * not obeyed. When the server value is unknown (partial user object, e.g. the
 * impersonation exchange), we fall back to the local flag without purging.
 * Callers must update the in-memory user (or local state) at dismiss time —
 * this helper will not honor the local flag once the server says false.
 */
export function isOnboardingDismissed(user: { tenantId?: string | null; onboardingDismissed?: boolean }): boolean {
  if (user.onboardingDismissed) return true
  const local = !!user.tenantId && localStorage.getItem(dismissKey(user.tenantId)) === 'true'
  if (user.onboardingDismissed === false) {
    if (local && user.tenantId) localStorage.removeItem(dismissKey(user.tenantId))
    return false
  }
  return local
}

export default {
  getOnboardingStatus,
  dismissOnboarding,
}
